import { useEffect, useState } from "react";
import { Loader2, DownloadCloud } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg } from "../../lib/api";

export const SyncPanel = ({ count, onDone }) => {
  const [st, setSt] = useState(null);
  const [email, setEmail] = useState("admin@pbtravelangel.com");
  const [pw, setPw] = useState("");
  const [from, setFrom] = useState("studio");
  const [src, setSrc] = useState("https://kit-generator-3.preview.emergentagent.com");
  const [busy, setBusy] = useState(false);
  const load = () => http.get("/extras/sync").then(({ data }) => setSt(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  useEffect(() => {
    if (!st?.running) return;
    const t = setInterval(() => { load(); onDone?.(); }, 6000);
    return () => clearInterval(t);
  }, [st?.running, onDone]);
  if (!st) return null;
  if (st.running) return (
    <div data-testid="ex-sync-running" className="ex-card p-5 mb-8 flex items-center gap-3 text-sm">
      <Loader2 size={16} className="animate-spin text-[#8B6B4A]" />
      Copying pictures and PDFs from Extras — {st.media_left ?? "…"} files left. Products already show; their images fill in as they arrive.
    </div>
  );
  if (count > 0 && st.finished_at && !st.missing) return null;
  if (count > 0 && !st.started_at) return null;
  const go = async () => {
    setBusy(true);
    try {
      const { data } = await http.post("/extras/sync", { email, password: pw, source: from === "studio" ? src : "" });
      toast.success(`${data.products} products copied — now copying ${data.media} pictures and PDFs`);
      setPw(""); load(); onDone?.();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div data-testid="ex-sync-panel" className="ex-card p-6 mb-10 flex flex-wrap items-end gap-4">
      <DownloadCloud size={22} className="text-[#8B6B4A]" />
      <div className="flex-1 min-w-[260px]">
        <div className="font-medium">{count > 0 ? `Copy products in again${st.missing ? ` — ${st.missing} files still missing` : ""}` : "Bring your PB Extras products in"}</div>
        <div className="text-sm text-stone-500">Copies every product with its listing, Instagram post, carousel, pictures and PDFs. The source isn't changed. Your password is only used for this copy and isn't stored.</div>
        <div className="flex flex-wrap gap-3 mt-3 text-sm">
          <label className="flex items-center gap-1.5"><input data-testid="ex-sync-from-studio" type="radio" checked={from === "studio"} onChange={() => setFrom("studio")} /> From another Kit Studio (e.g. the preview)</label>
          <label className="flex items-center gap-1.5"><input data-testid="ex-sync-from-extras" type="radio" checked={from === "extras"} onChange={() => setFrom("extras")} /> From extras.pbtravelangel.com</label>
        </div>
        {from === "studio" && <input data-testid="ex-sync-source" value={src} onChange={(e) => setSrc(e.target.value)} className="mt-2 h-10 rounded-md border border-stone-300 px-3 text-sm w-full max-w-md" />}
      </div>
      <input data-testid="ex-sync-email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-10 rounded-md border border-stone-300 px-3 text-sm w-56" />
      <input data-testid="ex-sync-password" type="password" placeholder="Extras password" value={pw} onChange={(e) => setPw(e.target.value)} className="h-10 rounded-md border border-stone-300 px-3 text-sm w-44" />
      <button data-testid="ex-sync-start" disabled={busy || !pw} onClick={go} className="ex-btn ex-btn-dark disabled:opacity-40">{busy && <Loader2 size={14} className="animate-spin" />} Copy my products</button>
    </div>
  );
};
